import React, { FC } from "react";
import { Switch, SwitchProps, styled } from "@mui/material";

const CustomStyledSwitch = styled(Switch)(({ theme }) => ({
    width: 26,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
        "& .MuiSwitch-switchBase.Mui-checked": {
            transform: "translateX(9px)",
        },
    },
    "& .MuiSwitch-switchBase": {
        padding: 2,
        "&.Mui-checked": {
            transform: "translateX(10px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor:
                    theme?.palette?.mode === "dark"
                        ? "#177ddc"
                        : theme?.custom?.mainButtonHighlight,
            },
        },
    },
    "& .MuiSwitch-thumb": {
        boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
        width: 12,
        height: 12,
        borderRadius: 6,
    },
    "& .MuiSwitch-track": {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme?.palette?.mode === "dark"
                ? "rgba(255,255,255,.35)"
                : theme?.custom?.mainIconColor,
        boxSizing: "border-box",
    },
}));

const IwSwitch: FC<SwitchProps> = (props) => {
    return <CustomStyledSwitch {...props} />;
};

export default IwSwitch;
